var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 20.5946L25.2335 28.3281C25.6439 28.7385 26.2005 28.969 26.7808 28.969C27.3612 28.969 27.9178 28.7385 28.3281 28.3281C28.7385 27.9177 28.969 27.3612 28.969 26.7808C28.969 26.2005 28.7385 25.6439 28.3281 25.2335L20.5917 17.5L28.3267 9.76644C28.5298 9.56324 28.6908 9.32204 28.8007 9.05659C28.9106 8.79114 28.9671 8.50665 28.9671 8.21936C28.967 7.93207 28.9103 7.6476 28.8003 7.38221C28.6903 7.11681 28.5291 6.87568 28.3259 6.67258C28.1227 6.46948 27.8815 6.3084 27.6161 6.19852C27.3506 6.08864 27.0661 6.03212 26.7789 6.03219C26.4916 6.03226 26.2071 6.08891 25.9417 6.19891C25.6763 6.30892 25.4352 6.47012 25.2321 6.67331L17.5 14.4069L9.76646 6.67331C9.56476 6.46429 9.32346 6.29753 9.05663 6.18276C8.78981 6.06799 8.50279 6.00751 8.21234 6.00485C7.92189 6.00219 7.63381 6.0574 7.36493 6.16727C7.09604 6.27713 6.85173 6.43944 6.64624 6.64474C6.44075 6.85003 6.27821 7.09419 6.16809 7.36297C6.05798 7.63175 6.00249 7.91978 6.00488 8.21023C6.00727 8.50069 6.06747 8.78776 6.18199 9.05469C6.29651 9.32163 6.46304 9.56309 6.67187 9.76498L14.4083 17.5L6.67333 25.235C6.4645 25.4369 6.29797 25.6783 6.18345 25.9453C6.06893 26.2122 6.00872 26.4993 6.00634 26.7897C6.00395 27.0802 6.05944 27.3682 6.16955 27.637C6.27967 27.9058 6.44221 28.1499 6.6477 28.3552C6.85318 28.5605 7.0975 28.7228 7.36638 28.8327C7.63527 28.9426 7.92334 28.9978 8.2138 28.9951C8.50425 28.9924 8.79126 28.932 9.05809 28.8172C9.32492 28.7024 9.56622 28.5357 9.76791 28.3266L17.5 20.5946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f4a4d6658ffcb7bdd8b396aa7b1bac6d.svg";
export { ForwardRef as ReactComponent };